
import { styled } from '@mui/system';
import { useTheme, Button, Dialog, IconButton, Stack, Typography } from '@mui/material';

import { useOnlineBookingLocale } from 'shell/OnlineBookingLocale';

import { IconCloseSmall } from 'assets/icons';

const StyledTypography = styled(Typography)(({ theme }) => ({
  margin: theme.spacing(0, 1),
  fontSize: '1rem',
  fontWeight: 500,
  "& > span": {
    color: theme.vars.palette.primary.main
  }
}));

const ConfirmDialog = ({ title, cancelId, cancelName, onClose, onCancel }) => {
  const { t } = useOnlineBookingLocale();
  const theme = useTheme();

  if (cancelId === undefined && cancelName === undefined) return null;

  return (
    <Dialog aria-labelledby='customer-record-dialog-title' onClose={onClose} open PaperProps={{ sx: { width: 600, p: 2 } }} >
      <Stack direction='row' justifyContent='space-between' alignItems='start'>
        <StyledTypography variant='h2' id='customer-record-dialog-title'>{title}<span> {cancelId ? `#${cancelId}` : cancelName}</span>?</StyledTypography>
        <IconButton title={t('common.actions.exit')} onClick={onClose} sx={{ p: 0, mx: 1, color: theme.vars.palette.primary.main }}>
          <IconCloseSmall />
        </IconButton>
      </Stack>
      <Stack direction='row' justifyContent='flex-end' alignItems='center' sx={{ mx: 1, mt: 3 }}>
        <Button sx={{ mx: 1 }} variant='text' color='primary' onClick={onClose}>{t('common.actions.no')}</Button>
        <Button sx={{ height: 40, minWidth: 47 }} variant='contained' color='primary' onClick={onCancel}>{t('common.actions.yes')}</Button>
      </Stack>
    </Dialog >
  );
}

export default ConfirmDialog;
